
















import blockMixin from './../BlockMixin.vue'
import ImageBlock from './ImageBlock.vue'

export default {
  name: 'gallery'

  mixins: [blockMixin]

  props: ['config']

  components: {
    ImageBlock
  }

  data: -> {
    fields: {
      blocks: [{
        blocktype: 'image'
        fields: {}
      }]
    }
  }

  methods: {
    addImage: ->

      this.block.fields.blocks.push({
        blocktype: 'image'
        fields: {}
      })

    removeImage: (index) ->
      this.block.fields.blocks.splice(index, 1)

      return if this.block.fields.blocks.length > 0
      this.$emit('remove-block', this.index)
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/blocks/GalleryBlock.vue